import React from 'react';
import Description from './Description';
import Errors from './Errors';
import Label from './Label';
var ControlsWrapper = function ControlsWrapper(_ref) {
  var className = _ref.className,
    children = _ref.children;
  return className ? /*#__PURE__*/React.createElement("div", {
    className: className
  }, children) : children;
};
var FormRow = function FormRow(_ref2) {
  var name = _ref2.name,
    label = _ref2.label,
    styles = _ref2.styles,
    children = _ref2.children,
    description = _ref2.description,
    required = _ref2.required,
    messages = _ref2.messages;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper ? styles.wrapper : 'mb-3 control-group'
  }, label ? /*#__PURE__*/React.createElement(Label, {
    styles: styles,
    label: label,
    required: required,
    name: name
  }) : null, /*#__PURE__*/React.createElement(ControlsWrapper, {
    className: styles.controlsWrapper
  }, /*#__PURE__*/React.createElement(Errors, {
    name: name,
    styles: styles,
    messages: messages
  }), /*#__PURE__*/React.createElement("div", {
    className: "controls ".concat(styles.controls || '')
  }, children), description ? /*#__PURE__*/React.createElement(Description, {
    styles: styles,
    description: description
  }) : null));
};
export default FormRow;